<div class="course-details-breadcrumb-1 bg_image rts-section-gap">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="single-course-left-align-wrapper">
          <div class="meta-area">
            <a class="text-white" [routerLink]="['/']">Início</a>
            <i class="fa-solid fa-chevron-right text-white"></i>
            <a class="active text-white" [routerLink]="['/atena-idiomas']"
              >Atena Idiomas</a
            >
          </div>
          <h1 class="title text-white">Conheça a Atena Idiomas</h1>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="about-area-start style-two mb--200">
  <div class="container">
    <p class="paragraph">
      Escola de idiomas do grupo Facint, com foco em fluência,
      internacionalização e capacitação linguística. Inglês, espanhol e outras
      línguas com metodologia moderna e voltada à conversação.
    </p>

    <a href="https://atenaidiomas.com.br" class="rts-btn btn-primary with-arrow"
      >Saiba mais <i class="fa-solid fa-arrow-right"></i
    ></a>
  </div>
</div>
